import { useButtonSideContext } from "../context/ButtonSideContext";
import { useShrinkContext } from "../context/ShrinkContext";
import { Pulse } from "./Svg";

export default function SideListMenu() {
  const [state, dispatch] = useButtonSideContext();
  const [shrink, setShrik] = useShrinkContext();
  return (
    <div className="earthquake-list">
      <p className="earthquake-list-title">
        <span
          className="shrink-button-active-m"
          onClick={() => setShrik({ type: "toggleShrink" })}
        >
          <svg
            xmlns="http://www.w3.org/2000/svg"
            viewBox="0 0 320 512"
            className={
              shrink.shrink
                ? "w-3 h-auto effect-transition min-[450px]:hidden"
                : "w-3 h-auto effect-transition min-[450px]:hidden"
            }
          >
            {/* <!--! Font Awesome Pro 6.2.1 by @fontawesome - https://fontawesome.com License - https://fontawesome.com/license (Commercial License) Copyright 2022 Fonticons, Inc. --> */}
            <path
              d="M41.4 233.4c-12.5 12.5-12.5 32.8 0 45.3l160 160c12.5 12.5 32.8 12.5 45.3 0s12.5-32.8 0-45.3L109.3 256 246.6 118.6c12.5-12.5 12.5-32.8 0-45.3s-32.8-12.5-45.3 0l-160 160z"
              fill="1e293b"
            />
          </svg>
        </span>
        <span className="mr-3">
          {" "}
          <Pulse size={"40"} />
        </span>
        List Gempa Terkini
        <span className="hidden min-[360px]:flex h-4 w-4 relative justify-center items-center mt-1 ml-3">
          <span className="animate-ping absolute  h-3 w-3 rounded-full bg-red-500 opacity-75"></span>
          <span className="animate-ping absolute  h-2 w-2 rounded-full bg-red-500 opacity-30"></span>
          <span className="relative  rounded-full h-3 w-3 bg-red-500"></span>
        </span>
      </p>
      <div className="flex gap-3">
        <button
          className={
            state.isFeltEarthquake
              ? "earthquake-list-button-active"
              : "earthquake-list-button"
          }
          onClick={() => dispatch({ type: "findFeltEarthquake" })}
        >
          Gempabumi dirasakan
        </button>
        <button
          className={
            state.isFiveEarthquake
              ? "earthquake-list-button-active"
              : "earthquake-list-button"
          }
          onClick={() => dispatch({ type: "findFiveEarthquake" })}
        >
          Gempabumi M 5.0+
        </button>
      </div>
    </div>
  );
}
